<template>
	<v-list-item>
		<v-list-item-avatar><UserAvatar :user="item" color="grey"></UserAvatar></v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title>{{item.display_name}}</v-list-item-title>
			<v-list-item-subtitle>
				<v-chip :color="item.role == 'admin' ? 'primary' : 'grey'" dark style="text-transform: uppercase" x-small>{{item.role}}</v-chip>
				{{item.email}}				
			</v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-icon>
			<v-btn icon color="primary" link :to="`users/${item.id}`"><v-icon>mdi-arrow-right-bold</v-icon></v-btn>
		</v-list-item-icon>
	</v-list-item>
</template>

<script>
	import UserAvatar from "@/components/info/UserAvatar"
	export default {
		name: "UserListItem",
		props: ["item"], 
		components: {
			UserAvatar
		}
	}
</script>